import { render } from "./Alert2.vue?vue&type=template&id=46e33a38"
import script from "./Alert2.vue?vue&type=script&lang=js"
export * from "./Alert2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__